import * as Yup from "yup";

import React, { useState } from "react";

import HeaderBanner from "../../../components/HeaderBanner";
import emailjs from "@emailjs/browser";
import { useFormik } from "formik";

const AdmissionForm = () => {
  const [isLoading, setIsLoading] = useState(false);

  const formik = useFormik({
    initialValues: {
      name: "",
      fatherName: "",
      email: "",
      phone: "",
      coursePreference: "",
      category: "",
      lastQualification: "",
      schoolCollege: "",
      percentage: "",
      query: "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Name is required"),
      fatherName: Yup.string().required("Father's name is required"),
      email: Yup.string().email("Invalid email"),
      phone: Yup.string()
        .required("Phone number is required")
        .matches(
          /^[6-9]\d{9}$/,
          "Phone number must be a valid 10-digit Indian number"
        ),
      coursePreference: Yup.string().required("Course is required"),
      category: Yup.string(),
      lastQualification: Yup.string(),
      schoolCollege: Yup.string(),
      percentage: Yup.string(),
    }),
    onSubmit: (values, { resetForm }) => {
      setIsLoading(true);

      const emailParams = {
        ...values,
        query: values.query || "No query submitted",
        to_email:
          "hodece@lkcengg.edu.in , assistantdirector@lkcengg.edu.in, rameshwer.banga@kclimt.com, sonu.dua@kclimt.com",
      };

      emailjs
        .send(
          "service_xlvsnfp_lkctc",
          "template_5h3hth9",
          emailParams,
          "T1o9eaPtzYX8qtsJj"
        )
        .then(
          (response) => {
            console.log("Email sent successfully!", response);
            alert("Form submitted successfully!");
            resetForm();
            setIsLoading(false);
          },
          (error) => {
            console.error("Email send error:", error);
            alert("Failed to send email. Please try again.");
            setIsLoading(false);
          }
        );
    },
  });

  return (
    <div>
      <HeaderBanner
        bgImage="bannerImg"
        title="Admissions"
        currentPage="Registration Form"
      />
      <div className="bannerBotttom h-[3.5rem] w-full"></div>

      <div className="flex justify-center items-center min-h-screen bg-gray-100 mt-20">
        <form
          onSubmit={formik.handleSubmit}
          className="max-w-2xl w-full bg-white p-6 shadow-md rounded-md border border-gray-300"
        >
          <h2 className="text-2xl font-bold text-center mb-4 text-gray-800">
            REGISTRATION FORM
          </h2>
          <p className="text-center text-gray-600 mb-4">
            Registration Open for Admission in Session 2025-26 <br />
            <strong>Lyallpur Khalsa College Technical Campus</strong> <br />
            Contact us:{" "}
            <span className="font-semibold">
              0181-2350400/405/406/412 Mobile: +91 9872476060 +91 9646904005 +91
              9814610383
            </span>
          </p>

          {[
            { name: "name", label: "Name", type: "text" },
            { name: "fatherName", label: "Father's Name", type: "text" },
            { name: "email", label: "Email", type: "email" },
            { name: "phone", label: "Phone Number", type: "tel" },
            {
              name: "schoolCollege",
              label:
                "Name of College/School/Polytechnic/ITI (Last Exam Passed/Appeared)",
              type: "text",
            },
            {
              name: "percentage",
              label:
                "Percentage or Result Awaited in Last Qualification Passed/Appeared",
              type: "text",
            },
          ].map((field) => (
            <div key={field.name} className="mb-4">
              <label className="block font-semibold text-gray-700 mb-1">
                {field.label}
              </label>
              <input
                name={field.name}
                type={field.type}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values[field.name]}
                className="w-full p-3 border border-gray-300 rounded-md focus:ring focus:ring-blue-300 outline-none"
              />
              {formik.touched[field.name] && formik.errors[field.name] && (
                <p className="text-red-500 text-sm">
                  {formik.errors[field.name]}
                </p>
              )}
            </div>
          ))}

          {/* Course Preference */}
          <div className="mb-4">
            <label className="block font-semibold text-gray-700 mb-1">
              Select Course Preference
            </label>
            <select
              name="coursePreference"
              value={formik.values.coursePreference}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              className="w-full p-3 border border-gray-300 rounded-md bg-white focus:ring focus:ring-blue-300 outline-none"
            >
              <option value="">Choose a course</option>
              {[
                "B-Tech CSE",
                "B.Tech Data Science",
                "B-Tech ECE",
                "B.Voc Electronics &IT",
                "B-Tech ME",
                "B.Voc AS",
                "B-Tech CE",
                "B.Voc Interior Design",
                "For B. Tech First Year (Common Laboratories)",
                "BHMCT AICTE",
                "BSc MLS",
                "BSc Radiology and Imaging Technology",
                "BSc Medical Technology Anaesthesia and Operation Theatre Technology",
                "BSc Graphics and Web Designing",
                "B. Com (Hons)",
                "BBA",
                "BCA",
                "MBA",
                "MCA",
                "MSc(Medical Microbiology)",
                "B.Voc(Software Development)",
                "B.Voc(Hospitality and Catering Management)",
                "B.Tech (AI and ML)",
                "MSc RIT",
                "MSc Medical Technology Anesthesia and OTT",
                "B.Voc(Web Technology and Multimedia)",
                "M.Sc. Medical Lab Science (Biochemistry)",
                "B.Sc. (Dialysis Technology)",
                "B.Sc. (Cardiac Care Technology)",
              ].map((course, i) => (
                <option key={i} value={course}>
                  {course}
                </option>
              ))}
            </select>
            {formik.touched.coursePreference &&
              formik.errors.coursePreference && (
                <p className="text-red-500 text-sm">
                  {formik.errors.coursePreference}
                </p>
              )}
          </div>

          {/* Category */}
          <div className="mb-4">
            <label className="block font-semibold text-gray-700 mb-2">
              Category
            </label>
            <div className="flex gap-4">
              {["General", "SC", "OBC", "Any Other"].map((cat, i) => (
                <label
                  key={i}
                  className="flex items-center gap-2 text-gray-700"
                >
                  <input
                    type="radio"
                    name="category"
                    value={cat}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    checked={formik.values.category === cat}
                  />
                  {cat}
                </label>
              ))}
            </div>
            {formik.touched.category && formik.errors.category && (
              <p className="text-red-500 text-sm">{formik.errors.category}</p>
            )}
          </div>

          {/* Last Qualification */}
          <div className="mb-4">
            <label className="block font-semibold text-gray-700 mb-2">
              Last Qualification Passed/Appeared
            </label>
            <div className="flex gap-4 flex-wrap">
              {["10th", "12th", "ITI", "Diploma", "Graduation"].map(
                (qual, i) => (
                  <label
                    key={i}
                    className="flex items-center gap-2 text-gray-700"
                  >
                    <input
                      type="radio"
                      name="lastQualification"
                      value={qual}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      checked={formik.values.lastQualification === qual}
                    />
                    {qual}
                  </label>
                )
              )}
            </div>
            {formik.touched.lastQualification &&
              formik.errors.lastQualification && (
                <p className="text-red-500 text-sm">
                  {formik.errors.lastQualification}
                </p>
              )}
          </div>

          {/* Query */}
          <div className="mb-4">
            <label className="block font-semibold text-gray-700 mb-1">
              Drop Your Query
            </label>
            <textarea
              name="query"
              onChange={formik.handleChange}
              value={formik.values.query}
              placeholder="Enter your query"
              className="w-full p-3 border border-gray-300 rounded-md focus:ring focus:ring-blue-300 outline-none"
            ></textarea>
          </div>

          {/* Submit Button */}
          <button
            type="submit"
            disabled={isLoading}
            className={`w-full bg-blue-500 text-white p-3 rounded-md font-semibold hover:bg-blue-600 flex justify-center items-center ${
              isLoading ? "opacity-50 cursor-not-allowed" : ""
            }`}
          >
            {isLoading ? (
              <div className="h-5 w-5 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
            ) : (
              "Submit"
            )}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdmissionForm;
